import {TITHI_ARE_LOADING, TITHI_FETCH_DATA_SUCCESS, TITHI_HAVE_ERROR} from '../actionType';

const initialState = {
    data: [],
    loading: true,
    error: []
  };
  
  export function TithiReducer (state = initialState, action) {
    switch (action.type) {
        case TITHI_HAVE_ERROR:
            return {
                ...state,
                error:action.hasError,
                loading:false,
            }
    
        case TITHI_ARE_LOADING:
           return {
            ...state,
            loading:action.isLoading
        }
    
        case TITHI_FETCH_DATA_SUCCESS:
            return {
                ...state,
                data:action.Tithi,
                loading:false,
            }

        default:
            return state;
    }
}

